export default "__VITE_ASSET__8504d599__"